import { createContext, useContext } from "react";

/**
 * Provides the current store's slug and the link "base" prefix.
 * - Platform mode (yoursaas.com/{slug}): base = "/{slug}"
 * - Custom-domain mode (shop.brand.com):  base = ""  (clean root URLs)
 *
 * All storefront links are built as `${base}/cart`, `${base}/product/x`, etc.
 * `slug` is always the real store slug (used for API calls like /store/{slug}/...).
 */
const StoreBaseContext = createContext({ slug: null, base: "", country: "IN" });

export function StoreBaseProvider({ value, children }) {
  return <StoreBaseContext.Provider value={value}>{children}</StoreBaseContext.Provider>;
}

export function useStoreBase() {
  return useContext(StoreBaseContext);
}
